export enum MatchingWeekRole {
  ADMIN = 'mw:admin',
  COMPANY = 'mw:company',
}

export enum MatchingWeekPermissions {
  CREATE_COMPANY = 'mw:create_company',
  MODIFY_COMPANY = 'mw:modify_company',
  DELETE_COMPANY = 'mw:delete_company',
  CREATE_USER = 'mw:create_user',
  MANAGE_SETTINGS = 'mw:manage_settings',
  MANAGE_MAIL_TEMPLATES = 'mw:manage_mail_templates',
}

export enum SUPER_ADMIN_PERMISSIONS {
  CREATE_COMPANY = MatchingWeekPermissions.CREATE_COMPANY,
  MODIFY_COMPANY = MatchingWeekPermissions.MODIFY_COMPANY,
  DELETE_COMPANY = MatchingWeekPermissions.DELETE_COMPANY,
  CREATE_USER = MatchingWeekPermissions.CREATE_USER,
  MANAGE_SETTINGS = MatchingWeekPermissions.MANAGE_SETTINGS,
  MANAGE_MAIL_TEMPLATES = MatchingWeekPermissions.MANAGE_MAIL_TEMPLATES,
  IMPERSONATE = 'Users.Impersonate',
}
